import { Tab, Tabs } from '@mui/material';
import { useState } from 'react';

import { HumanTaskDynamicConfigFormFields } from './FormFields';
import { HumanTaskGeneralFormFields } from '../GeneralTab/FormFields';
import { HumanTaskWorkContextTabs } from '../WorkContexts/WorkContextTabs';

enum HumanTaskDynamicConfigTab {
  TaskFields = 'TaskFields',
  WorkContexts = 'WorkContexts',
  General = 'General',
}

export function HumanTaskDynamicConfigTabs() {
  const [selectedTab, setSelectedTab] = useState<HumanTaskDynamicConfigTab>(
    HumanTaskDynamicConfigTab.TaskFields
  );

  return (
    <>
      <Tabs
        value={selectedTab}
        onChange={(_event, newTab) => {
          setSelectedTab(newTab);
        }}
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
        }}
      >
        <Tab label="Task Fields" value={HumanTaskDynamicConfigTab.TaskFields} />
        <Tab label="Work Contexts" value={HumanTaskDynamicConfigTab.WorkContexts} />
        <Tab label="General" value={HumanTaskDynamicConfigTab.General} />
      </Tabs>
      {selectedTab === HumanTaskDynamicConfigTab.TaskFields && <HumanTaskDynamicConfigFormFields />}
      {selectedTab === HumanTaskDynamicConfigTab.WorkContexts && <HumanTaskWorkContextTabs />}
      {selectedTab === HumanTaskDynamicConfigTab.General && <HumanTaskGeneralFormFields />}
    </>
  );
}
